import { FormControl, FormLabel, VStack } from '@chakra-ui/react';
import { useEventInfo } from '@frx/frx-react-context';
import { DonationAmounts } from './DonationAmounts';
import { useDonationForm } from '../../hooks';
import { DonationOtherAmount } from './DonationOtherAmount';
import { ASK_ARRAY, ASK_ARRAY_SIZES } from '../../constants';

export type DonationArrayProps = {
  handleOtherActive: () => void;
  handleOtherFocus: () => void;
  isOtherAmountActive: boolean;
};
export const DonationArray = ({
  handleOtherActive,
  handleOtherFocus,
  isOtherAmountActive,
}: DonationArrayProps) => {
  const { getOtherLevelId } = useDonationForm();
  const { data: trInfo } = useEventInfo();
  const eventType = (trInfo?.public_event_type_name || '').toLowerCase();
  const levels = ASK_ARRAY[eventType] || ASK_ARRAY_SIZES.md;
  const otherFieldLevelId = getOtherLevelId();

  return (
    <VStack spacing={4} w="full">
      <FormControl>
        <FormLabel>Donation Amount ($USD)</FormLabel>
        <DonationAmounts
          donationAmount={0}
          levels={levels}
          onChange={handleOtherActive}
        />
      </FormControl>
      <DonationOtherAmount
        isActive={isOtherAmountActive}
        onFocus={handleOtherFocus}
        otherLevelId={otherFieldLevelId}
      />
    </VStack>
  );
};
